import {Entity} from '@s-ui/domain'

export class DraftEntity extends Entity {
  /**
   * @constructor
   * @param {Object}    data
   * @param {Number}    data.id
   * @param {Number}    data.body
   * @param {String}    data.carPlate
   * @param {Number}    data.colour
   * @param {String}    data.comments
   * @param {Number}    data.fuel
   * @param {Boolean}   data.hidePhone
   * @param {Array}     data.images
   * @param {String}    data.km
   * @param {Number}    data.make
   * @param {Number}    data.model
   * @param {Number}    data.phone
   * @param {String}    data.plateRegistrationDate
   * @param {Number}    data.price
   * @param {Number}    data.province
   * @param {Bool}      data.publishInMA
   * @param {Number}    data.transmission
   * @param {String}    data.userId
   * @param {Number}   data.version
   * @param {Number}   data.year
   * @param {String}   data.zipCode
   * */

  /**
   * Validation method
   * @param {Object} param
   * @param {String} param.id
   * @param {DraftError} param.invalidDraftError
   */
  static validate({id, invalidDraftError, userId}) {
    const hasId = Boolean(id)
    const hasUserId = Boolean(userId)

    if (hasUserId && !hasId) {
      throw invalidDraftError({message: '[DraftEntity] Authenticated user draft has not an ID'})
    }
  }

  getAdId() {
    return this._data.id
  }

  getUserId() {
    return this._data.userId
  }
}
